// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".search-form[data-v-2ad63c02] .el-form-item__content{max-width:100%}.search-form[data-v-2ad63c02] .el-form-item__label{min-width:70px;width:85px}", ""]);
// Exports
module.exports = exports;
